import { render, staticRenderFns } from "./SidebarLimitUser.vue?vue&type=template&id=28e544da&scoped=true"
import script from "./SidebarLimitUser.vue?vue&type=script&lang=js"
export * from "./SidebarLimitUser.vue?vue&type=script&lang=js"
import style0 from "./SidebarLimitUser.vue?vue&type=style&index=0&id=28e544da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e544da",
  null
  
)

export default component.exports